import {
  ApiOutlined,
  LinkOutlined,
  MessageOutlined,
  QuestionCircleOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ojServiceLinks = [
  { to: '/submissions', label: '评测记录' },
  { to: '/ranklist', label: '排行榜' },
  { to: '/schedules', label: '题单' }
];

const developerLinks = [
  { to: '/api-doc', label: 'API 文档' },
  { to: '/help', label: '使用帮助' }
];

const aboutLinks = [
  { to: '/terms', label: '服务条款' },
  { to: '/privacy', label: '隐私政策' },
  { to: '/youth', label: '青少年保护' }
];

export function SiteFooter() {
  const [site, setSite] = useState({ icp: '', babh: '', beianUrl: 'https://beian.miit.gov.cn/', publicSecurityUrl: 'https://www.beian.gov.cn/' });

  useEffect(() => {
    let alive = true;
    fetch('/api/front-v2/auth/bootstrap', { credentials: 'include' })
      .then((response) => (response.ok ? response.json() : null))
      .then((payload) => {
        if (!alive || !payload?.site) return;
        setSite({
          icp: payload.site.icp || '',
          babh: payload.site.babh || '',
          beianUrl: payload.site.beianUrl || 'https://beian.miit.gov.cn/',
          publicSecurityUrl: payload.site.publicSecurityUrl || 'https://www.beian.gov.cn/'
        });
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  return (
    <footer className="site-footer-v2">
      <div className="site-footer-inner">
        <section className="footer-brand-block">
          <Link to="/home" className="footer-brand-lockup" aria-label="Becoder">
            <span className="footer-brand-mark">B</span>
            <span>
              <strong>Becoder</strong>
              <small>必可</small>
            </span>
          </Link>
          <p>面向算法竞赛训练、NOI 系列赛事与 AI 辅助学习的在线评测平台</p>
          <div className="footer-contact-row">
            <a href="mailto:becoder@yeah.net">
              becoder@yeah.net
            </a>
          </div>
        </section>

        <nav className="footer-link-group" aria-label="OJ 服务">
          <div className="footer-section-title">OJ 服务</div>
          <div className="footer-link-list">
            {ojServiceLinks.map((item) => (
              <Link to={item.to} key={item.to}>{item.label}</Link>
            ))}
          </div>
        </nav>

        <nav className="footer-link-group" aria-label="开发支持">
          <div className="footer-section-title">开发支持</div>
          <div className="footer-link-list">
            {developerLinks.map((item) => (
              <Link to={item.to} key={item.to}>
                <span>{item.label}</span>
              </Link>
            ))}
            <a href="mailto:becoder@yeah.net"><span>联系我们</span></a>
          </div>
        </nav>

        <nav className="footer-link-group" aria-label="关于平台">
          <div className="footer-section-title">关于平台</div>
          <div className="footer-link-list">
            {aboutLinks.map((item) => (
              <Link to={item.to} key={item.to}>{item.label}</Link>
            ))}
          </div>
        </nav>
      </div>
      <div className="site-footer-bottom">
        <div className="footer-bottom-brand">
          <span>© 2026 Becoder</span>
          <span>为有品位的算法竞赛爱好者设计</span>
        </div>
        <div className="footer-bottom-records" aria-label="备案信息">
          <span>
            <img className="footer-record-police-icon" src="https://www.beian.gov.cn/img/ghs.png" alt="" aria-hidden="true" />
            <a href={site.publicSecurityUrl} target="_blank" rel="noreferrer">{site.babh || '公安备案信息'}</a>
          </span>
          <span>
            <LinkOutlined />
            <a href={site.beianUrl} target="_blank" rel="noreferrer">{site.icp || 'ICP备案信息'}</a>
          </span>
          <span><SafetyCertificateOutlined />版权所属：必可</span>
        </div>
      </div>
    </footer>
  );
}
